<template>
  <div class="app-payment-change-wrapper">
    <div class="text"><slot name="txtBefore"></slot></div>
    <ShowPaymentData :key="changed">
      <template v-for="slot in possibleChildSlotsFor('ViewWrapper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowPaymentData>
    <ChangePaymentData
      :credit-card-frame-address="creditCardFrameAddress"
      :credit-card-redirect-url="creditCardRedirectUrl"
    >
      <template v-for="slot in possibleChildSlotsFor('Wrapper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ChangePaymentData>
  </div>
</template>

<script>

import ChangePaymentData from '../ChangePaymentData.vue'
import ShowPaymentData from '../ShowPaymentData.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
import { mapGetters } from 'vuex'

export default {
  name: 'ChangePaymentWrapper',
  components: { ChangePaymentData, ShowPaymentData },
  mixins: [
    transaction('changePayment'),
    slotProxy()
  ],
  computed: {
    ...mapGetters('changePayment', [
      'paymentTypeChanged'
    ]),
    changed: function () {
      return this.paymentTypeChanged
    }
  },
  props: {
    creditCardFrameAddress: {
      type: String,
      required: true
    },
    creditCardRedirectUrl: {
      type: String
    }
  }
}
</script>
